import {
    GET_OMS_STOCK_STYLE_WISE_SUMMARY_REPORT_REQUEST,
    GET_OMS_STOCK_STYLE_WISE_SUMMARY_REPORT_SUCCESS,
    GET_OMS_STOCK_STYLE_WISE_SUMMARY_REPORT_ERROR,
    GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_REQUEST,
    GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_SUCCESS,
    GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_ERROR,
    GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_NEW_REQUEST,
    GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_NEW_SUCCESS,
    GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_NEW_ERROR
} from "./types.js";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getOmsStockStyleWiseSummary = (token, data, seasonID, statusID, PCID, BgradeCheck) => (dispatch) => {    
    dispatch({ type: GET_OMS_STOCK_STYLE_WISE_SUMMARY_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getOtsSummaryStyleWiseReport`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            from_date: moment(data.from_date).format("YYYY-MM-DD"),
            to_date: moment(data.to_date).format("YYYY-MM-DD"),
            as_on_date: moment(data.as_on_date).format("YYYY-MM-DD"),
            style_id: data.style_id === "All" ? null : data.style_id,
            fit_category_id: !data.fit_id || data.fit_id === "All" ? null : data.fit_id,
            gender_id: data.gender_id === "All" ? null : data.gender_id,
            product_status_id: statusID.length > 0 ? statusID.toString() : null,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_OMS_STOCK_STYLE_WISE_SUMMARY_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_OMS_STOCK_STYLE_WISE_SUMMARY_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_OMS_STOCK_STYLE_WISE_SUMMARY_REPORT_ERROR,
                payload: error.response,
            });
        });
};

export const getOmsFitWiseSummary = (token, data, statusID, BgradeCheck) => (dispatch) => {
    dispatch({ type: GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/OtsSummaryFitCategory`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            as_on_date: moment(data.as_on_date).format("YYYY-MM-DD"),
            style_id: !data.style_id || data.style_id === "All" ? null : data.style_id,
            fit_cat_id: !data.fit_id || data.fit_id === "All" ? null : data.fit_id,
            gender_id: !data.gender_id || data.gender_id === "All" ? null : data.gender_id,
            product_status_id: statusID.length > 0 ? statusID.toString() : null,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_ERROR,
                payload: error.response,
            });
        });
};

export const getOmsFitWiseSummaryNew = (token, data, statusID, BgradeCheck) => (dispatch) => {
    dispatch({ type: GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_NEW_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/OtsSummaryFitCategoryNew`,

        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            as_on_date: moment(data.as_on_date).format("YYYY-MM-DD"),
            style_id: !data.style_id || data.style_id === "All" ? null : data.style_id,
            cut_id: !data.cut_id || data.cut_id === "All" ? null : data.cut_id,
            gender_id: !data.gender_id || data.gender_id === "All" ? null : data.gender_id,
            product_status_id: statusID.length > 0 ? statusID.toString() : null,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_NEW_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_NEW_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_OMS_STOCK_FIT_WISE_SUMMARY_REPORT_NEW_ERROR,
                payload: error.response,
            });
        });
};
